import { render, staticRenderFns } from "./newHome.vue?vue&type=template&id=155e597e&scoped=true"
import script from "./newHome.vue?vue&type=script&lang=js"
export * from "./newHome.vue?vue&type=script&lang=js"
import style0 from "./newHome.vue?vue&type=style&index=0&id=155e597e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155e597e",
  null
  
)

export default component.exports